export default "__VITE_ASSET__zyGizNLf__"